import React from 'react';

export const SectionHead = ({ eyebrow, title, sub, id }) => (
  <div className="mk-head">
    {eyebrow && <p className="mk-eyebrow">{eyebrow}</p>}
    <h2 id={id}>{title}</h2>
    {sub && <p className="mk-sub">{sub}</p>}
  </div>
);
